// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__2VDIS","footer":"ChangeClinic_footer__wGX6U"};